// based on rc-trigger 2.6.5
import Trigger from './Trigger';
export default Trigger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-trigger/index.js
// module id = null
// module chunks = 